import { Outlet } from "react-router-dom";
import Header from "./Header";

const PageContainer = () => {
  return (
    <div>
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-7">
        <Outlet />
      </div>
    </div>
  );
};

export default PageContainer;
